{
  "clear": "Tøm",
  "invalid": "(ugyldig)",
  "loading": "Laster inn ...",
  "noResults": "Ingen resultater",
  "valid": "(gyldig)"
}
